var map = {
	"./account_balance_24dp.svg": 3890,
	"./add-disabled.svg": 95725,
	"./add.svg": 71480,
	"./alert-icon.svg": 91811,
	"./app-icon.svg": 13842,
	"./arrow-down.svg": 31759,
	"./arrow-left.svg": 65648,
	"./arrow-white.svg": 78210,
	"./arrow_disabled_left.svg": 56507,
	"./arrow_disabled_left_white.svg": 25061,
	"./arrow_disabled_right.svg": 92862,
	"./arrow_enabled_left.svg": 12636,
	"./arrow_enabled_right.svg": 24259,
	"./assignment-ind.svg": 53260,
	"./bank-icon.svg": 7709,
	"./beta-menu.svg": 41687,
	"./beta.svg": 65873,
	"./better-v.svg": 75308,
	"./blacktrash.svg": 19910,
	"./broken-link-icon.svg": 87937,
	"./butterfly.svg": 19480,
	"./cash.svg": 52442,
	"./challenge-action.svg": 36101,
	"./chat_icon_dark_green.svg": 2678,
	"./chat_icon_secondary.svg": 57156,
	"./chat_icon_small.svg": 50371,
	"./chat_icon_small_teriatry.svg": 9808,
	"./chat_icon_small_white.svg": 85437,
	"./chat_icon_teriatry.svg": 90280,
	"./chat_icon_teriatry_white.svg": 79474,
	"./check-green-icon.svg": 40251,
	"./check-light-blue.svg": 50867,
	"./check-list.svg": 95714,
	"./check_mark.svg": 15367,
	"./checkmark-blue-little.svg": 73768,
	"./close-fat.svg": 37823,
	"./close-thin.svg": 6207,
	"./close-white.svg": 33025,
	"./close.svg": 35837,
	"./clover-check-mark.svg": 71691,
	"./comment.svg": 29886,
	"./credit-card-icon-disabled.svg": 67208,
	"./credit-card-icon.svg": 49415,
	"./credit-card-outline.svg": 88822,
	"./credit-card.svg": 48531,
	"./credit_card_24dp.svg": 5294,
	"./credit_card_24dp_gray.svg": 15444,
	"./discount-icon.svg": 22360,
	"./dome-check-mark.svg": 67953,
	"./edit-prediction.svg": 22071,
	"./edits-exclude.svg": 45563,
	"./edits-is-savings.svg": 32013,
	"./edits-move.svg": 61404,
	"./edits-not-savings.svg": 26136,
	"./edits-sub-category.svg": 2200,
	"./edits-trash.svg": 60711,
	"./event.svg": 67449,
	"./exclamation-mark-green.svg": 73322,
	"./exclamation-mark-pink.svg": 94973,
	"./exclamation-mark.svg": 80288,
	"./exclemation-mark-blue.svg": 36221,
	"./exclemation-mark-coral.svg": 21504,
	"./exclemation-mark-gray.svg": 31264,
	"./exclemation-mark-red.svg": 76374,
	"./exclemation-mark-yellow.svg": 38957,
	"./expand-arrow-down-medium-disabled.svg": 48877,
	"./expand-arrow-down-medium.svg": 92152,
	"./expand-arrow-down-small-disabled.svg": 62187,
	"./expand-arrow-down-small.svg": 44738,
	"./filter_active.svg": 50530,
	"./flag-grey.svg": 14871,
	"./flag.svg": 41113,
	"./gift.svg": 66081,
	"./graph-bars.svg": 55656,
	"./graph-line.svg": 96104,
	"./gray-pencil.svg": 78272,
	"./green-gift.svg": 6307,
	"./group-5.svg": 94250,
	"./hands_raised.png": 56452,
	"./heart-icon.svg": 56233,
	"./heart.svg": 49733,
	"./ic-close.svg": 65112,
	"./icon-check-blue.svg": 51572,
	"./icon-lock-gray.svg": 24488,
	"./icon_add.svg": 85808,
	"./icon_add_member.svg": 70681,
	"./icon_edit.svg": 50919,
	"./icon_left_arrow.svg": 17702,
	"./icon_supermarket.svg": 57320,
	"./info-icon-blue.svg": 3708,
	"./info-icon-grey.svg": 5801,
	"./left-triangle.svg": 96573,
	"./light-three-dots.svg": 64347,
	"./location-marker.svg": 16885,
	"./lock-blue.svg": 72595,
	"./lock-grey.svg": 67926,
	"./lock-outline.svg": 82643,
	"./menu-white.svg": 77374,
	"./menu.svg": 72434,
	"./missing-card.svg": 59152,
	"./modal-close-blue.svg": 3150,
	"./modal-close-mustard.svg": 36788,
	"./mode-edit.svg": 83559,
	"./mortgages-flower.svg": 51416,
	"./next-month-triangle.svg": 84618,
	"./notice-gray.svg": 25741,
	"./notice-green.png": 75827,
	"./orange-x.svg": 70462,
	"./pending.svg": 87352,
	"./phone-vector.svg": 24707,
	"./pink-flower.svg": 82217,
	"./present.svg": 8368,
	"./previous-month-triangle.svg": 59586,
	"./profile/secondary-4.svg": 9622,
	"./question-mark-icon.svg": 24003,
	"./rami-levi-new-stamp.svg": 90610,
	"./redtrash.svg": 45830,
	"./remove.svg": 82315,
	"./right-triangle.svg": 44840,
	"./sad-smiley-blue.svg": 19100,
	"./sad-smiley-grey.svg": 48073,
	"./savings-not-fixed.svg": 47109,
	"./savings-not-variable.svg": 15701,
	"./search-grey.svg": 32665,
	"./search-vector.svg": 60397,
	"./search.svg": 64343,
	"./small_check.svg": 78421,
	"./smiling-smiley-blue.svg": 93277,
	"./smiling-smiley-grey.svg": 21812,
	"./split.svg": 58933,
	"./star-check-mark.svg": 63406,
	"./star-white.svg": 62495,
	"./success-icon.svg": 24662,
	"./temp_transaction_large.svg": 51600,
	"./temp_transaction_small.svg": 93304,
	"./three-dots.svg": 81462,
	"./thumbs-down.svg": 76469,
	"./thumbs-up.svg": 31066,
	"./trash.svg": 36891,
	"./unknown-error.png": 84202,
	"./v-blue.svg": 97876,
	"./v-outline-filled-pink.svg": 52036,
	"./v-outline.svg": 31562,
	"./v-white.svg": 90463,
	"./verified.svg": 25523,
	"./vertical-three-dots.svg": 73023,
	"./video-icon-blue.svg": 18219,
	"./wallet-vector.svg": 11876,
	"./warning-icon.svg": 12517,
	"./whatsapp-icon.svg": 11813,
	"./white-pencil.svg": 68620,
	"./white-trash.svg": 70871,
	"./yellow-sun.svg": 68394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;